import { useCallback } from 'react';

import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import { InboxEntry } from '@this+that/models';

const GENERATE_DOBOX_FROM_COMMUNICATION = gql`
  mutation generateDoBoxFromCommunication(
    $input: GenerateDoBoxFromCommunicationInput!
  ) {
    generateDoBoxFromCommunication(input: $input) {
      id
      createdAt
      createdFor
      subject
      description
      participantIds
      communicationIds
      dueAt
      resolvedAt
      updatedAt
      priority
      taskGroupId
      taskLabelIds
    }
  }
`;

interface GenerateDoBoxFromCommunicationData {
  generateDoBoxFromCommunication: InboxEntry;
}

export function useGenerateDoBoxFromCommunication() {
  const [mutate, { loading, error }] =
    useMutation<GenerateDoBoxFromCommunicationData>(
      GENERATE_DOBOX_FROM_COMMUNICATION,
    );

  const generateDoBoxFromCommunication = useCallback(
    async (
      messageId: string,
      taskGroupId: string,
    ): Promise<InboxEntry | null> => {
      const { data } = await mutate({
        variables: { input: { messageId, taskGroupId } },
      });
      return data?.generateDoBoxFromCommunication ?? null;
    },
    [mutate],
  );

  return { generateDoBoxFromCommunication, loading, error };
}
